import React from 'react';
import { observer } from 'mobx-react';
import { FieldKey } from '../connection-template-form.config';
import Text from '../../../../global/text/text';
import { EnablementStatus } from '../../../../../constants/common.constants';
import { PODIUM_LINK_TEXT } from '../connection-template-form.texts';
import DefaultButton from '../../../../global/default-button/default-button';
import { MANAGE_PODIUM_ACCESS_TEXT } from '../../../../_events/_manage-event/_connections/_meeting-connections-form/meeting-connections-form.texts';
import { ConnectionTemplatesFormVM } from '../connection-template-form.viewmodel';

export interface IConnectionTemplatePodiumPresentationProps {
    vm: ConnectionTemplatesFormVM;
}

const ConnectionTemplatePodiumPresentation = observer(({
    vm
}: IConnectionTemplatePodiumPresentationProps) => {
    const {
        podiumLinkEnabled,
    } = vm.getFormFields(FieldKey);

    return (
        <>
            <div className='m-bottom-20px'>
                <Text
                    {...PODIUM_LINK_TEXT}
                    values={{
                        suffix: podiumLinkEnabled.value ? EnablementStatus.ENABLED : EnablementStatus.DISABLED
                    }}
                />
            </div>
            <DefaultButton
                modifier='fat'
                text={vm.getIntl.formatMessage(MANAGE_PODIUM_ACCESS_TEXT)}
                onClick={vm.openPodiumPopup}
                className='manage-podium-access'
            />
        </>
    );
});

export default ConnectionTemplatePodiumPresentation;
